export function PageHeader({ title, description, actions, testId, eyebrow }) {
  return (
    <div className="mb-6 flex flex-wrap items-start justify-between gap-4" data-testid={testId || "page-header"}>
      <div className="max-w-3xl">
        {eyebrow && <div className="tqi-eyebrow mb-1">{eyebrow}</div>}
        <h1 className="tqi-page-title">{title}</h1>
        {description && <p className="mt-1.5 text-sm text-slate-600 leading-relaxed">{description}</p>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2 shrink-0">{actions}</div>}
    </div>
  );
}

export function Callout({ tone = "info", title, children, testId }) {
  const tones = { info: "border-blue-200/80 bg-blue-50/60 text-blue-900", warn: "border-amber-200 bg-amber-50 text-amber-900", danger: "border-rose-200 bg-rose-50 text-rose-900", neutral: "border-slate-200 bg-slate-50 text-slate-700" };
  return (
    <div className={`rounded-lg border px-4 py-3 text-sm ${tones[tone]}`} data-testid={testId}>
      {title && <div className="font-semibold">{title}</div>}
      <div className={title ? "mt-1 leading-relaxed" : "leading-relaxed"}>{children}</div>
    </div>
  );
}

export function WhatThisMeans({ children, testId }) {
  return <div className="tqi-help" data-testid={testId || "what-this-means"}><span className="mt-0.5 grid h-4 w-4 shrink-0 place-items-center rounded-full bg-[#101C47] text-[10px] font-bold text-white">i</span><div><span className="font-semibold">What this means for you: </span>{children}</div></div>;
}

export function Field({ label, children, hint }) {
  return (
    <label className="block space-y-1.5">
      <span className="text-xs font-semibold uppercase tracking-wider text-slate-500">{label}</span>
      {children}
      {hint && <span className="block text-xs text-slate-500">{hint}</span>}
    </label>
  );
}
